// extracted by mini-css-extract-plugin
export default {"list":"styles_list__1hnAx","chart":"styles_chart__awULg"};